import React from 'react';
import { FormattedMessage } from 'react-intl';
import SectionContent from './components/SectionContent';


export default class AboutThisEntity extends React.Component {
    render() {
        return (
            <div className="about-this-entity">

                <div className="section-header">
                    <FormattedMessage id="Dashboard_SingleView_UIText_aboutThisEntity_header"/>
                </div>

                <SectionContent companyId={this.props.companyId}
                                companyData={this.props.companyData}
                                categories={this.props.categories}
                                experianData={this.props.experianData}
                />

            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/scripts/pages/EntityDashboard/components/AboutThisEntity/AboutThisEntity.jsx